import ANTDCheckbox, { ANTDCheckboxGroup } from './antd/ANTDCheckbox'
import { ANTDDatePicker } from './antd/ANTDDatePicker'
import ANTDInput, { ANTDPassword, ANTDTextArea } from './antd/ANTDInput'
import ANTDInputNumber from './antd/ANTDInputNumber'
import { ANTDRadioGroup } from './antd/ANTDRadio'
import ANTDSelect from './antd/ANTDSelect'
import ParentSelector from '../components/catalogueManagement/presentation/ParentSelector'
import UploadImage from '../components/common/presentation/UploadImage'
import CatalogueSelector from '../components/jobs/presentation/common/CatalogueSelector'
import EquipmentSelect from '../components/jobs/presentation/common/EquipmentSelect'
import ErrorCodeField from '../components/jobs/presentation/common/ErrorCodeField'
import RefrigerantType from '../components/jobs/presentation/common/RefrigerantType'

const getFormInput = ({ inputType }) => {
  switch (inputType) {
    case 'input':
    case 'INPUT':
      return ANTDInput
    case 'password':
      return ANTDPassword
    case 'inputNumber':
    case 'INPUT_NUMBER':
      return ANTDInputNumber
    case 'textArea':
    case 'TEXT_AREA':
      return ANTDTextArea
    case 'select':
      return ANTDSelect
    case 'checkbox':
      return ANTDCheckbox
    case 'checkboxGroup':
    case 'CHECKBOX':
      return ANTDCheckboxGroup
    case 'RADIO_BUTTON':
    case 'TOGGLE_BUTTON':
      return ANTDRadioGroup
    case 'image':
    case 'IMAGE':
      return UploadImage
    case 'dateTimePicker':
      return ANTDDatePicker
    case 'parentSelector':
      return ParentSelector
    case 'equipmentSelect':
      return EquipmentSelect
    case 'errorCode':
      return ErrorCodeField
    case 'catalogueSelector':
      return CatalogueSelector
    case 'refrigerantType':
      return RefrigerantType

    default:
      return ANTDInput
  }
}
export default getFormInput
